import { Alert, Grid, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { IDocumentDownloaded } from '../../Interfaces/IDocumentDownloaded';
import { ILegalPhaseFullObject } from '../../Interfaces/ILegalPhase';
import { ILegalRequirement } from '../../Interfaces/ILegalRequirement';
import { ILegalRequirementState } from '../../Interfaces/ILegalRequirementState';
import { LegalInfoText } from './LegalInfoText';
import { LegalRequirementRow } from './LegalRequirementRow';

interface IProps {
  legalPhaseFullObject: ILegalPhaseFullObject;
  legalPhaseFullObjectArray: ILegalPhaseFullObject[];
  setLegalPhaseFullObjectArray: Function;
  legalReqState: ILegalRequirementState[];
  downloadedArray?: IDocumentDownloaded[];
  startdatedeadline: Date | undefined;
}

export const LegalPhaseRow: React.FC<IProps> = ({
  legalPhaseFullObject,
  legalPhaseFullObjectArray,
  setLegalPhaseFullObjectArray,
  legalReqState,
  downloadedArray,
  startdatedeadline,
}) => {
  const [isNotDisabled, setIsNotDisabled] = useState(
    legalPhaseFullObject.PreconditionArray.length === 0 ||
      legalPhaseFullObject.PreconditionArray.every(x => {
        const testObject = legalPhaseFullObjectArray.find(
          y => y.idLegalPhase === x.idLegalPhase
        );

        if (testObject === undefined) {
          return false;
        } else {
          return testObject.isComplete === true;
        }
      })
  );

  const setLegalPhaseObject = (updatedObject: ILegalPhaseFullObject) => {
    setLegalPhaseFullObjectArray([
      ...legalPhaseFullObjectArray.map(x =>
        x.idLegalPhase === updatedObject.idLegalPhase ? updatedObject : x
      ),
    ]);
  };

  const setLegalReqArray = (updatedArray: ILegalRequirement[]) => {
    setLegalPhaseObject({
      ...legalPhaseFullObject,
      isComplete: updatedArray.every(x => x.idLegalRequirementState === 40),
      LegalRequirementArray: updatedArray,
    });
  };

  useEffect(() => {
    setIsNotDisabled(
      legalPhaseFullObject.PreconditionArray.length === 0 ||
        legalPhaseFullObject.PreconditionArray.every(x => {
          const testObject = legalPhaseFullObjectArray.find(
            y => y.idLegalPhase === x.idLegalPhase
          );

          if (testObject === undefined) {
            return false;
          } else {
            return testObject.isComplete === true;
          }
        })
    );
  }, [legalPhaseFullObjectArray]);

  return (
    <>
      <Grid item sm={12}>
        <Alert
          variant={isNotDisabled ? 'standard' : 'outlined'}
          severity={legalPhaseFullObject.isComplete ? 'success' : 'info'}
          action={
            <>
              <LegalInfoText currentObject={legalPhaseFullObject} />
            </>
          }
        >
          {legalPhaseFullObject.LegalPhase}
          {legalPhaseFullObject.AdministrativeUnit !== null &&
            legalPhaseFullObject.AdministrativeUnit !== undefined && (
              <>
                <br />
                <Typography variant='caption' mb={1} mt={1}>
                  Zugewiesene Gemarkung:{' '}
                  {legalPhaseFullObject.AdministrativeUnit}
                </Typography>
              </>
            )}

          {legalPhaseFullObject.PreconditionArray.length !== 0 && (
            <>
              <br />
              <Typography variant='caption'>Vorgänger:</Typography>{' '}
            </>
          )}
          {
            <Typography variant='caption'>
              {legalPhaseFullObject.PreconditionArray.map(
                x => x.LegalPhase
              ).join(', ')}
            </Typography>
          }
        </Alert>
      </Grid>
      {legalPhaseFullObject.LegalRequirementArray.map((x, i) => (
        <React.Fragment key={i}>
          <Grid item sm={3} lg={1}></Grid>
          <Grid item sm={9} lg={11}>
            <LegalRequirementRow
              legalRequirement={x}
              legalRequirementArray={legalPhaseFullObject.LegalRequirementArray}
              setLegalRequirementArray={setLegalReqArray}
              isNotDisabled={isNotDisabled}
              legalReqState={legalReqState}
              downloadedArray={downloadedArray}
              startDeadlineDate={startdatedeadline}
            />
          </Grid>
        </React.Fragment>
      ))}
    </>
  );
};
